import { useCallback, useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { ShieldOff, ChevronLeft } from "lucide-react";
import { api, errMsg } from "../../lib/api";
import { useAuth } from "../../lib/auth";
import { Empty } from "../../components/kit";
import { JobSummary, CustomerCard, NextStep, PhotoJumpButton } from "../../components/JobParts";
import Condition from "../../components/Condition";
import { AuthImg } from "../../components/Photos";

export default function SpecJob() {
  const { id } = useParams();
  const { user } = useAuth();
  const [job, setJob] = useState(null);
  const [err, setErr] = useState("");
  const [jump, setJump] = useState(null);
  const load = useCallback(async () => {
    try {
      const { data } = await api.get(`/jobs/${id}`);
      setJob(data);
    } catch (e) {
      setErr(errMsg(e));
    }
  }, [id]);
  useEffect(() => {
    load();
  }, [load]);
  if (err)
    return (
      <div>
        <Empty icon={ShieldOff} title="Not available" text={err} />
        <Link to="/s/jobs" className="block text-center text-sm text-[#FF6B00]" data-testid="back-to-my-jobs">Back to My jobs</Link>
      </div>
    );
  if (!job) return <div className="h-40 animate-pulse bg-[#141414] rounded-2xl" />;
  const intake = job.photos.filter((p) => p.phase === "intake");
  return (
    <div className="space-y-4 fade-in" data-testid="specialist-job-page">
      <Link to="/s/jobs" className="text-sm text-neutral-500 flex items-center gap-1"><ChevronLeft className="w-4 h-4" />My jobs</Link>
      {!['cancelled'].includes(job.status) && <PhotoJumpButton job={job} onJump={setJump} />}
      <JobSummary job={job} payout={job.payout} />
      <CustomerCard job={job} />
      {intake.length > 0 && (
        <div className="grid grid-cols-4 gap-2">{intake.map((p) => <AuthImg key={p.id} id={p.id} className="aspect-square rounded-lg w-full" />)}</div>
      )}
      <p className="text-xs text-neutral-500">Accepting committed you to the appointment window. Contact Driven if anything changes.</p>
      <NextStep job={job} reload={load} />
      <Condition job={job} user={user} reload={load} jump={jump} />
    </div>
  );
}
